import { useSelector } from 'react-redux';
import { RfUiInput } from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  makeSelectMinutesPracticeSelected,
  makeSelectMinutesPracticeSelectedError,
} from 'store/app/selectors';
import { makeSelectPracticaSeleccionada } from 'store/practicas/selectors';
import { language } from 'utils/literals';

const selectors = createStructuredSelector({
  minutesPracticeSelected: makeSelectMinutesPracticeSelected(),
  minutesPracticeSelectedError: makeSelectMinutesPracticeSelectedError(),
  practicaSeleccionada: makeSelectPracticaSeleccionada(),
} as any);

export const MinutesContainer = () => {
  const { minutesPracticeSelected, minutesPracticeSelectedError } = useSelector<
    any,
    any
  >(selectors);

  return (
    <>
      <div className="rf-box__parent">
        <div className="rf-practice-create__input-container">
          <RfUiInput
            label={language.informacionPractica.minutosLabel}
            textError={
              minutesPracticeSelectedError ? minutesPracticeSelectedError : ''
            }
            error={''}
            className="rf-input"
            disabled
            placeholder="- - - - - - - - -"
            value={minutesPracticeSelected?.toString()}
          />
        </div>
      </div>
    </>
  );
};
